<script>
import {Link} from "@inertiajs/vue3";
import Scroll from "@vvg/forum/js/mixins/scroll.js";

export default {
	name: "ProfileIndex",
	components: {Link},
	mixins: [Scroll],
	props: {
		user: {
			type: Object,
			required: true
		}
	},
	mounted() {
		this.$nextTick(() => this.scrollToForum());
	},
	methods: {
		goBack() {
			if (window.history.length > 1) {
				window.history.back();
			} else {
				this.$inertia.visit(this.$page.props.forum_url);
			}
		}
	}
}
</script>

<template>
	<div class="container-xl py-4">

		<div class="d-flex justify-content-between align-items-start mb-4">
		<nav class="topic-breadcrumb" aria-label="Navigatie">
			<Link :href="$page.props.forum_url" class="topic-breadcrumb__link">Forum</Link>
			<i class="fa fa-chevron-right topic-breadcrumb__sep"></i>
			<span class="text-muted">Profiel</span>
		</nav>
			<button
				type="button"
				@click="goBack"
				class="btn btn-dark btn-sm d-flex align-items-center gap-2"
			>
				<i class="fa fa-arrow-left"></i> Terug
			</button>
		</div>

		<div class="profile-card">
			<div class="profile-card__header">
				<div class="profile-card__avatar">
					<img
						v-if="user.profile_picture_url"
						:src="user.profile_picture_url"
						:alt="user.username"
						class="profile-card__photo"
					/>
					<div v-else class="profile-card__initials">
						{{ (user.username ?? 'O').slice(0, 2).toUpperCase() }}
					</div>
				</div>
				<h1 class="profile-card__username">{{ user.username }}</h1>
			</div>

			<div v-if="user.sector" class="profile-card__sector">
				<i class="fa fa-briefcase"></i>
				{{ user.sector }}
			</div>
		</div>

	</div>
</template>

<style scoped>
.profile-card {
	background: #fff;
	border: 1px solid #e9ecef;
	border-radius: 8px;
	padding: 2rem;
	max-width: 860px;
}

.profile-card__header {
	display: flex;
	align-items: center;
	gap: 1.5rem;
	margin-bottom: 1.5rem;
}

.profile-card__avatar {
	flex-shrink: 0;
}

.profile-card__photo {
	width: 96px;
	height: 96px;
	border-radius: 50%;
	object-fit: cover;
}

.profile-card__initials {
	width: 96px;
	height: 96px;
	border-radius: 50%;
	background: #343a40;
	color: #fff;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 2rem;
	font-weight: 600;
}

.profile-card__username {
	font-size: 1.4rem;
	font-weight: 600;
	margin: 0;
}

.profile-card__sector {
	color: #495057;
	font-size: 0.95rem;
	line-height: 1.7;
	white-space: pre-wrap;
	word-break: break-word;
}

.profile-card__sector .fa {
	margin-right: 6px;
	margin-top: 3px;
	flex-shrink: 0;
	align-self: flex-start;
}
</style>
